/**
 * Build-time feature flags.
 *
 * Toggled via `REACT_APP_*` env vars at build time. Switching a flag
 * requires a rebuild + redeploy.
 */
export const FEATURE_FLAGS = {
  /**
   * Post-match referee feedback questionnaire.
   * Enable by setting REACT_APP_FEEDBACK_ENABLED=true at build time.
   */
  postMatchFeedback: process.env.REACT_APP_FEEDBACK_ENABLED === 'true',
};
